
const FlagThree = () => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="21"
            viewBox="0 0 40 21"
            aria-label="Flag of Russia"
        >
            <rect width="40" height="7" y="0" fill="#FFFFFF"/>
            <rect width="40" height="7" y="7" fill="#0033A0"/>
            <rect width="40" height="7" y="14" fill="#D52B1E"/>
        </svg>
    );
};

export default FlagThree;